import type { FleetRecord } from '../../../types'
import { FleetCard } from './FleetCard'
import { Plus } from 'lucide-react'

type FleetsGridProps = {
  fleets: FleetRecord[]
  onToggleActive: (id: string) => void
  onEdit: (id: string) => void
  onCreate: () => void
  updatingIds: Set<string>
}

const CreateFleetCard = ({ onCreate }: { onCreate: () => void }) => (
  <button
    type="button"
    onClick={onCreate}
    className="flex min-h-[350px] w-full max-w-[280px] flex-col items-center justify-center gap-[16px] rounded-[16px] border border-dashed border-[#B0B0B0] bg-transparent p-[24px] transition-colors hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#FF6A1A] focus:ring-offset-2"
  >
    <div className="flex size-[48px] items-center justify-center rounded-full bg-[#333333] text-white">
      <Plus size={24} strokeWidth={2.5} />
    </div>

    <div className="flex flex-col items-center gap-[8px] text-center">
      <span className="font-host text-[18px] font-semibold text-[#B0B0B0]">
        Add New Vehicle
      </span>

      <span className="font-host text-[13px] text-[#B0B0B0]">
        Add a new vehicle to your fleet
      </span>
    </div>
  </button>
)

export const FleetsGrid = ({
  fleets,
  onToggleActive,
  onEdit,
  onCreate,
  updatingIds,
}: FleetsGridProps) => {
  if (fleets.length === 0) {
    return (
      <div className="flex flex-col items-center gap-[25px]">
        <p className="w-full py-[40px] text-center font-host text-[16px] font-normal leading-normal text-dash-col-head">
          No vehicles in your fleet.
        </p>

        <CreateFleetCard onCreate={onCreate} />
      </div>
    )
  }

  const orderedFleets = [...fleets].sort(
    (a, b) =>
      (a.displayOrder ?? 0) -
      (b.displayOrder ?? 0),
  )

  return (
    <div className="grid grid-cols-1 gap-[24px] sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {orderedFleets.map((fleet) => (
        <FleetCard
          key={fleet.id}
          onEdit={onEdit}
          onToggleActive={onToggleActive}
          isUpdating={updatingIds.has(fleet.id)}
          fleet={fleet}
        />
      ))}

      <CreateFleetCard onCreate={onCreate} />
    </div>
  )
}